import axios from 'axios';
import { io } from 'socket.io-client';

/**
 * ==========================================
 * CONFIGURATION ERP LEDI EXPERT PRO (CLOUD/WEB/MOBILE)
 * ==========================================
 */

// Utilisation des variables d'environnement React (REACT_APP_API_URL) 
// ou repli sur l'hôte courant / localhost si non défini
const getApiBaseUrl = () => {
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
    }
    // Si l'application tourne dans un navigateur web standard
    if (typeof window !== 'undefined' && window.location && window.location.origin) {
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            const port = process.env.REACT_APP_PORT || 3030;
            return `http://${window.location.hostname}:${port}`;
        }
        // Utilise automatiquement le domaine courant en production (ex: https://...)
        return window.location.origin;
    }
    return 'http://localhost:3030';
};

const SERVER_URL = getApiBaseUrl();
const SOCKET_URL = SERVER_URL;
const BASE_URL = `${SERVER_URL}/api`;

console.log('🚀 LEDI ERP - Mode Cloud / Web / Mobile activé');
console.log(`📡 Connexion au serveur : ${BASE_URL}`);

/**
 * ==========================================
 * INITIALISATION SOCKET.IO
 * ==========================================
 */

export const socket = io(SOCKET_URL, {
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    timeout: 20000,
});

/**
 * ==========================================
 * ÉVÉNEMENTS SOCKET
 * ==========================================
 */

socket.on('connect', () => {
    console.log('✅ Socket connecté au serveur cloud');
});

socket.on('disconnect', () => {
    console.log('❌ Socket déconnecté');
});

socket.on('connect_error', (err) => {
    console.error('❌ Erreur Socket.IO :', err.message);
});

/**
 * ==========================================
 * REJOINDRE LA ROOM ENTREPRISE
 * ==========================================
 */

export const joinCompanyRoom = () => {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const companyId = user.company_id || user.companyId;

        if (companyId && socket.connected) {
            socket.emit('join_company', companyId.toString());
            console.log(`🏢 Room entreprise rejointe : ${companyId}`);
        }
    } catch (err) {
        console.error('Erreur joinCompanyRoom :', err);
    }
};

socket.on('connect', () => {
    joinCompanyRoom();
});

/**
 * ==========================================
 * CONFIGURATION AXIOS
 * ==========================================
 */

const API = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

/**
 * ==========================================
 * INTERCEPTEUR DE REQUÊTE
 * ==========================================
 */

API.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        const user = JSON.parse(localStorage.getItem('user') || '{}');

        const companyId =
            user.company_id ||
            user.companyId ||
            localStorage.getItem('companyId') ||
            1;

        // JWT
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Société active
        config.headers['x-company-id'] = companyId;

        // Infos utilisateur
        if (user.id) {
            config.headers['x-user-id'] = user.id;
            config.headers['x-user-permissions'] = JSON.stringify(user.permissions || {});
            config.headers['x-license-caps'] = JSON.stringify(user.mod || []);
        }

        return config;
    },
    (error) => Promise.reject(error)
);

/**
 * ==========================================
 * INTERCEPTEUR DE RÉPONSE
 * ==========================================
 */

API.interceptors.response.use(
    (response) => {
        const method = response.config.method?.toLowerCase();

        // Notification temps réel des modifications de données
        if (['post', 'put', 'delete', 'patch'].includes(method)) {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const companyId = user.company_id || user.companyId;

            if (companyId && socket.connected) {
                socket.emit('DATA_CHANGED', {
                    companyId: companyId.toString(),
                    url: response.config.url
                });
            }
        }

        return response;
    },
    (error) => {
        if (!error.response) {
            console.error('🌐 ERREUR RÉSEAU : Impossible de joindre le serveur distant.');
            console.error(`📡 URL testée : ${BASE_URL}`);
            return Promise.reject(error);
        }

        if (error.response.status === 403) {
            console.warn('⛔ Accès refusé');
            return Promise.reject(error);
        }

        if (error.response.status === 401) {
            console.warn('🔒 Session expirée');
            localStorage.removeItem('token');
            localStorage.removeItem('user');

            if (!window.location.hash.includes('/login')) {
                window.location.href = '/#/login';
            }
        }

        return Promise.reject(error);
    }
);

export default API;